<template lang="pug">
header.navbar.navbar-expand.flex-column.navbar-light.bg-white.flex-md-row.bd-navbar.py-md-3.shadow-sm.px-0.px-md-3
  router-link.navbar-brand.me-0.me-md-auto.mx-2(to="/garage", alt="Pipe Technology")
    img.me-1.mb-1(src="https://pipe.bot/img/logo.svg", width="24", height="24")
    | Pipe
    span.d-sm-inline.d-none &nbsp;Technology

  nav#navbarScroll.navbar-nav-scroll.me-md-2
    ul.navbar-nav.pipe-navbar-nav.flex-row
      .px-2
      li.nav-item.ml-md-2(v-for="item in menu")
        .dropdown.d-none.d-md-block(v-if="item.dropdown")
          a.nav-link.dropdown-toggle(
            :id="`dropdownMenu${item.name}`",
            href="#",
            role="button",
            data-bs-toggle="dropdown",
            aria-expanded="false"
          ) {{ item.name }}
          ul.dropdown-menu(:aria-labelledby="`dropdownMenu${item.name}`")
            li(v-for="dropdownItem in item.dropdown")
              router-link.dropdown-item(v-if="dropdownItem.routerLink", :to="dropdownItem.routerLink") {{ dropdownItem.name }}
              a.dropdown-item(v-else, :href="dropdownItem.link") {{ dropdownItem.name }}
        template(v-if="item.link")
          a.nav-link(v-if="item.target" :href="item.link" :target="item.target") {{item.name}}
          a.nav-link(v-else, :href="item.link", :class="{'d-md-none': item.dropdownItem}") {{item.name}}
</template>

<script>
import { getClientInfo } from '@/services/api/user.api'

export default {
  data() {
    return {
      userRole: 'admin',
      menu: [
        { name: 'Pricing', link: '/pricing' },
        { name: 'Media', link: '/media' },
        { name: 'Documentation', link: '/docs' },
        {
          name: 'API',
          link: 'https://pipebot.docs.apiary.io/',
          target: '_blank'
        },
        { name: 'Logout', link: '/logout' }
      ]
    }
  },
  async created() {
    await this.fillMenuItems()
  },
  methods: {
    async fillMenuItems() {
      const userRole = await this.getClientRole()
      if (userRole === 'admin') {
        const dropdownItems = [
          { name: 'Contracts', dropdownItem: true, link: '/cave/contracts' },
          { name: 'Leaderboard', dropdownItem: true, link: '/leaderboard' },
          { name: 'Heroes', dropdownItem: true, link: '/heroes' }
        ]
        dropdownItems.reverse().forEach((item) => {
          this.menu.splice(4, 0, item)
        })
        this.menu.splice(4, 0, {
          name: 'Statistics',
          dropdown: dropdownItems
        })
      }
    },
    async getClientRole() {
      try {
        const clientToken = this.$cookie.get('clientToken')
        if (!clientToken) return ''
        const clientInfo = await getClientInfo(clientToken)
        return clientInfo.data.attributes.role
      } catch (err) {
        console.error(`Couldn't get user role: ${err}`)
        return ''
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.navbar, .navbar-expand
  .navbar-nav-scroll
    max-width: 100%
    height: 2.4rem

@media (max-width: 991.98px)
  .navbar-nav-scroll .navbar-nav
    padding-bottom: 2rem
    white-space: nowrap
    -webkit-overflow-scrolling: touch

@media (max-width: 576px)
  #navbarScroll.navbar-nav-scroll
    overflow-x: auto
    white-space: nowrap
    overflow: hidden
    font-size: 0.875rem
    -webkit-overflow-scrolling: touch
    -webkit-box-orient: horizontal
    -webkit-box-direction: normal

    ul.pipe-navbar-nav
      overflow-x: auto
</style>
